/**
 * Sentry `dataCollection` for every `Sentry.init` (client, server, edge).
 *
 * @sentry/nextjs v11 replaced `sendDefaultPii` with `dataCollection`, and
 * the default flipped: with `dataCollection` unset, v11 collects IP address
 * and user info, cookies, request/response headers and bodies, query
 * params, AI inputs/outputs and database query data. v10 with
 * `sendDefaultPii` unset (our setup) collected none of that.
 *
 * This is Sentry's documented "keep the v10 collection defaults" config
 * (docs.sentry.io/platforms/javascript/guides/nextjs/migration/v10-to-v11/).
 * Keep it in one place so the three runtimes can't drift apart, and don't
 * loosen it without checking the privacy policy.
 */
const HEADER_DENY = ["forwarded", "-ip", "remote-", "via", "-user"];
// Query keys that can carry client text. `ask` is the legacy chat deep-link
// (/dashboard/chat?ask=<message>); the app no longer writes it, but old links
// and bookmarks still arrive with one.
const QUERY_DENY = [...HEADER_DENY, "ask"];

export const SENTRY_DATA_COLLECTION = {
  userInfo: false,
  cookies: false,
  httpHeaders: {
    request: { deny: HEADER_DENY },
    response: { deny: HEADER_DENY },
  },
  httpBodies: [],
  urlQueryParams: { deny: QUERY_DENY },
  genAI: { inputs: false, outputs: false },
  databaseQueryData: false,
  graphQL: { document: false, variables: false },
};
